export interface Document {
    fileName?: string;
    mimeType?: string;
    filePath?: string;
    type?: string;
}


export enum DocumentType {
    Image = 'image',
    File = 'file',
    Video = 'video',
    Link = 'link',
    Customer = 'customer',
    Inventory = 'inventory',
}